<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
    <div class="lg:flex flex-1 gap-2">
        <!-- Trip Form -->

        <div
            class="overflow-hidden h-full p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg flex-1">
            <form [formGroup]="newTripForm">
                <div>
                    <div class="flex items-center justify-between flex-wrap gap-2  py-2">
                        <h3 class="text-lg font-medium leading-6 text-xs-dark">
                            Adjust
                        </h3>
                        <!-- Fare Details -->
                        <div class="flex gap-2 items-center border border-gray-300 dark:border-white/25 px-[3px] py-[5px] rounded-[5px]">
                            <div *ngIf="fareDetails || fareCancelDetails" class="flex items-center justify-between flex-wrap gap-2">
                                <ng-container *ngIf="tripData.status == 'completed'">
                                    <div class="flex gap-2">
                                        <div *ngIf="fareDetails" class="flex justify-between gap-2">
                                            <div class="border border-sky-500/20 text-xs-light gap-1 rounded-lg p-2 bg-primary/5">
                                                <ul class="flex flex-wrap space-y-1">
                                                    <li class="flex items-center justify-between w-full">
                                                        <div class="flex items-center space-x-1">
                                                           
                                                        <div class="text-xs text-primary">Total Fare: </div>
                                                        </div>
                                                        <p class="text-xs-dark ml-1">
                                                            <span class="text-white bg-blue-800 p-1 rounded-md">
                                                                ${{ fareDetails && fareDetails.total ? formatValue(fareDetails.total) : 0 }}
                                                            </span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div *ngIf="tripData?.specialRate" class="flex justify-between gap-2">
                                            <div class="border border-sky-500/20 text-xs-light gap-1 rounded-lg p-2 bg-primary/5 ring-2 ring-black ring-offset-1">
                                                <ul class="flex flex-wrap items-center gap-2">
                                                    <li class="flex items-center gap-1">
                                                        <div class="text-xs text-primary">Special Fare: </div>
                                                        <p class="text-xs-dark">
                                                            <span class="text-white bg-blue-800 p-1 rounded-md">
                                                                ${{ formatValue(tripData.specialRate) }}
                                                            </span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                    
                                <ng-container *ngIf="tripData.status == 'cancelled'">
                                    <div *ngIf="fareCancelDetails" class="flex justify-between gap-y-2 gap-x-4">
                                        <div *ngIf="!(tripData.flags.isNoShow)" class="text-xs-light gap-1 rounded-lg  p-2 bg-red-500 text-white shadow-md">
                                            <ul class="flex flex-wrap space-y-1">
                    
                                                <li class="flex items-center justify-between w-full">
                                                    <div class="flex items-center space-x-1">
                                                      
                                                        <div class="text-xs font-semibold text-white">Cancel Charges:</div>
                                                    </div>
                                                    <p class="text-xs-dark ml-1">
                                                        <span class="bg-white text-green-700 px-2 py-1 rounded-md font-bold shadow-sm">
                                                            ${{ fareCancelDetails?.cancelCharges || 0 }}
                                                        </span>
                                                    </p>
                                                </li>
                    
                                            </ul>
                                        </div>
                    
                                        <div *ngIf="tripData.flags?.isNoShow" class="text-xs-light gap-1 rounded-lg  p-2 bg-red-500 text-white shadow-md">
                                            <ul class="flex flex-wrap space-y-1">
                    
                                                <li class="flex items-center justify-between w-full">
                                                    <div class="flex items-center space-x-1">
                                                        <div class="text-xs font-semibold text-white">Noshow Charges:</div>
                                                    </div>
                                                    <p class="text-xs-dark ml-1">
                                                        <span class="bg-white text-green-700 px-2 py-1 rounded-md font-bold shadow-sm">
                                                            ${{ fareCancelDetails?.noShowCharges || 0 }}
                                                        </span>
                                                    </p>
                                                </li>
                    
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                    
                            </div>
                    
                            <div *ngIf="tripData">
                                <span class="py-2 "
                                    [ngClass]="tripData?.status === 'cancelled' ? 'badge-danger border border-red-400/40' : 'badge-success border border-green-400/40'">{{tripData?.status |
                                    titlecase}}</span>
                            </div>
                            <button (click)="opendetailModal()" class="btn btn-secondary" title="View Details">Details</button>
                    
                        </div>
                    </div>

                <div class="w-72 mt-4">
                        <label class="block text-sm font-medium text-main-secondary">Member</label>
                        <div class="mt-1 input-display">
                            {{ (this.selectedMember.displayName) | titlecase }}
                        </div>
                    </div>


                    <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                        <div class="sm:col-span-2">
                            <label for="reference" class="block text-sm font-medium text-main-secondary">Reference ID
                            </label>
                            <div class="mt-1 input-display">
                                {{tripData?.reference}}
                                <!-- <input formControlName="reference" type="text" name="reference" id="reference" /> -->
                            </div>
                        </div>
                        <!-- Suffix -->
                        <div class="sm:col-span-2">
                            <label for="suffix" class="block text-sm font-medium text-main-secondary">Leg
                            </label>
                            <div class="mt-1 input-display">
                                {{(tripData?.suffix) | titlecase}}
                                <!-- <input formControlName="suffix" type="text" name="suffix" id="suffix" /> -->
                            </div>
                        </div>
                        <!-- <div class="sm:col-span-2">
                            <label for="los" class="block text-sm font-medium text-main-secondary">Funding Source <span
                                    class="text-red-600">*</span></label>
                            <div class="mt-1">
                                <ng-select id="los" formControlName="fundingsource" [clearable]="false" [ngClass]="
                    submitted && form.fundingsource.errors?.required
                      ? 'border-main-danger'
                      : 'border-gray-300'
                  ">
                                    <ng-option value="">Select Funding Source</ng-option>
                                    <ng-option *ngFor="let fundingSource of fundingSourceList"
                                        value="{{ fundingSource.id }}">{{ fundingSource.title | capitalize }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="form.fundingsource.errors && submitted">
                                <div *ngIf="form.fundingsource.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Funding Source is required
                                    </p>
                                </div>
                            </div>
                        </div> -->

                        <div class="sm:col-span-2">
                            <label for="serviceArea" class="block text-sm font-medium text-main-secondary">
                                Service Area
                            </label>
                            <div class="mt-1 input-display">
                                {{ ((preServiceAreaList?.[newTripForm.get('serviceArea')?.value]?.title) | titlecase) || '' }}
                            </div>
                        </div>


                        <div class="sm:col-span-2">
                            <label for="los" class="block text-sm font-medium text-main-secondary">
                                Level of Service <span class="text-red-600">*</span>
                            </label>
                            <div class="mt-1 input-display">
                                {{ ((preLevelOfServiceList?.[form.levelOfService.value]?.title) | uppercase) || '' }}
                            </div>
                        </div>

                        <div *ngIf="spaceTypeList.length > 0" class="sm:col-span-2">
                            <label for="spaceType" class="block text-sm font-medium text-main-secondary">
                                Space Type <span class="text-red-600">*</span>
                            </label>
                            <div class="mt-1 input-display">
                                {{ ((preSpaceTypeList?.[newTripForm.get('spaceType')?.value]?.title) | uppercase) || '' }}
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <label for="driver" class="block text-sm font-medium text-main-secondary">Driver</label>
                            <div class="mt-1">
                                <ng-select id="driver" formControlName="driver" [clearable]="false" class="">
                                    <ng-option [value]="null">
                                        Select Driver
                                    </ng-option>
                                    <ng-option *ngFor="let driver of driverList" value="{{ driver.id }}">
                                        {{driver.displayName | titlecase }} - {{ driver.contactNumber }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="form.driver.errors && submitted">
                                <div *ngIf="form.driver.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Driver is required
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <label for="vehicle" class="block text-sm font-medium text-main-secondary">Vehicle</label>
                            <div class="mt-1">
                                <ng-select id="vehicle" formControlName="vehicle" [clearable]="false" class="">
                                    <ng-option [value]="null">
                                        Select Vehicle
                                    </ng-option>
                                    <ng-option *ngFor="let vehicle of vehicleList" value="{{ vehicle.id }}">{{
                                        vehicle.model
                                        | titlecase }} - {{ vehicle.licensePlateNumber }}</ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="form.vehicle.errors && submitted">
                                <div *ngIf="form.vehicle.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Vehicle is required
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div formGroupName="pickup" name="pickup">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-xs-dark">Pickup</h3>
                        </div>
                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                            <div
                                class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2">
                                <div>
                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">
                                            <!-- time -->
                                            <div class="sm:col-span-3">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Time
                                                </label>
                                                <div class="mt-1 relative input-display">

                                                    {{tripData?.pickup?.time | date:'MM/DD/YYYY HHmm'}}
                                                    <!-- <input type="text" name="pickupTime" id="pickupTime"
                                                        formControlName="time" [owlDateTime]="dtPickUpTime"
                                                        [owlDateTimeTrigger]="dtPickUpTime" /> -->
                                                    <div
                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <span class="text-gray-500 sm:text-sm" id="price-currency">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                class="h-5 w-5 text-xs-light" viewBox="0 0 24 24">
                                                                <g fill="none" stroke="currentColor"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2">
                                                                    <path
                                                                        d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                    <path
                                                                        d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                    <path d="M18 16.496V18l1 1" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>


                                                <!-- <owl-date-time (afterPickerClosed)="onPickupDateChange(pickUpForm.get('time'))" #dtPickUpTime></owl-date-time> -->
                                            </div>

                                            <!-- address -->
                                            <div class="sm:col-span-3" formGroupName="address">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Address <span
                                                        class="text-red-600">*</span>
                                                </label>
                                                <div class="mt-1 input-display">
                                                    {{tripData?.pickup?.address?.name}}
                                                    <!-- <input type="text" id="pickupAddress" class=""
                                                        placeholder="Enter the address" name="pickupAddress" googlePlace
                                                        formControlName="name" (onSelect)="setOriginAddress($event)" /> -->
                                                </div>
                                            </div>
                                        </div>

                                        <details class="col-span-full group">
                                            <summary class="flex items-center justify-between cursor-pointer">
                                                <div class="text-xs font-bold underline flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="size-4">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                                    </svg>
                                                    Additional Information
                                                </div>
                                                <svg class="h-5 w-5 transition-transform duration-300 ease-in-out group-open:rotate-180"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                </svg>
                                            </summary>
                                            <div
                                                class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-6 items-end border p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 border-zinc-950/10 dark:border-white/10">
                                                <ng-container formGroupName="address">

                                                    <div class="sm:col-span-2">
                                                        <label for="floor"
                                                            class="block text-sm font-medium text-main-secondary">Floor
                                                        </label>
                                                        <div class="mt-1 input-display">
                                                            {{tripData?.pickup?.address?.floor}}
                                                            <!-- <input formControlName="floor" type="text" name="floor"
                                                                id="floor" /> -->
                                                        </div>
                                                        <!-- <div *ngIf="originAddressAdditionalForm.get('floor')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('floor')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Floor is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>

                                                    <!-- APT/SUITE -->
                                                    <div class="sm:col-span-2">
                                                        <label for="aptOrSuite"
                                                            class="block text-sm font-medium text-main-secondary">APT/SUITE
                                                        </label>
                                                        <div class="mt-1 input-display">
                                                            {{tripData?.pickup?.address?.aptSuiteRoom}}
                                                            <!-- <input formControlName="aptSuiteRoom" type="text"
                                                                name="aptOrSuite" id="aptOrSuite" /> -->
                                                        </div>
                                                        <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            APT/SUITE is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>

                                                </ng-container>

                                                <!-- Place Type -->
                                                <div class="sm:col-span-2">
                                                    <label for="placeName"
                                                        class="block text-sm font-medium text-main-secondary">Place Type
                                                    </label>
                                                    <div class="mt-1 input-display">
                                                        {{tripData?.destination?.placeName}}
                                                        <!-- <select name="placeNameAddres" id="placeNameAddres"
                                                            formControlName="placeName">
                                                            <option value="">Select Place Name</option>
                                                            <option *ngFor="let placetype of placetypes"
                                                                value="{{ placetype.title }}">
                                                                {{ placetype.title }}
                                                            </option>
                                                        </select> -->
                                                    </div>
                                                    <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Home/Facility Name is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                </div>

                                                <!-- Contact Number -->
                                                <div class="sm:col-span-2">
                                                    <label for="phoneNumber"
                                                        class="block text-sm font-medium text-main-secondary">Contact
                                                        Number
                                                    </label>
                                                    <div class="mt-1 input-display" phoneNumberFormat [phoneNumber]="tripData?.pickup?.phoneNumber">
                                                        {{tripData?.pickup?.phoneNumber}}
                                                        <!-- <input formControlName="phoneNumber" type="text" name="phoneNumber" id="phoneNumber" maxlength="11" /> -->
                                                    </div>
                                                    <!-- <div *ngIf="submitted && pickUpForm.get('phoneNumber')?.errors">
                                                    <p *ngIf="submitted &&(pickUpForm.get('phoneNumber')?.errors?.minlength || pickUpForm.get('phoneNumber')?.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                                                            Minimum 10 digits are required and maximum 11
                                                            digits are allowed
                                                    </p>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </details>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div formGroupName="destination" name="destination">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-xs-dark">
                                Dropoff
                            </h3>
                        </div>
                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                            <div
                                class="sm:col-span-6 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg space-y-2">
                                <div>
                                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                        <div class="col-span-full grid grid-cols-1 gap-2 sm:grid-cols-6">
                                            <!-- time -->
                                            <div class="sm:col-span-3">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Time
                                                </label>
                                                <div class="mt-1 relative input-display">
                                                    {{tripData?.destination?.time | date:'MM/DD/YYYY HHmm'}}
                                                    <!-- <input type="text" name="dropoffTime" id="dropoffTime"
                                                        formControlName="time" [owlDateTime]="dtDropOffTime"
                                                        [owlDateTimeTrigger]="dtDropOffTime" /> -->
                                                    <div
                                                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <span class="text-gray-500 sm:text-sm" id="price-currency">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                class="h-5 w-5 text-xs-light" viewBox="0 0 24 24">
                                                                <g fill="none" stroke="currentColor"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2">
                                                                    <path
                                                                        d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                                    <path
                                                                        d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                                    <path d="M18 16.496V18l1 1" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>

                                                <!-- <div *ngIf="dropOffForm.controls.time.errors && submitted">
                                                    <div *ngIf="dropOffForm.controls.time.errors.required" class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Time is required
                                                        </p>
                                                    </div>
                                                    <div *ngIf="dropOffForm.controls.time.errors.owlDateTimeMin" class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Time is required
                                                        </p>
                                                    </div>
                                                </div>
                                                <owl-date-time (afterPickerClosed)="onDateChange(dropOffForm.get('time'))" #dtDropOffTime></owl-date-time> -->
                                            </div>
                                            <!--                                        
                                            address -->
                                            <div formGroupName="address" class="sm:col-span-3">
                                                <label for="Address"
                                                    class="block text-sm font-medium text-main-secondary">Address <span
                                                        class="text-red-600">*</span>
                                                </label>
                                                <div class="mt-1 input-display">
                                                    {{tripData?.destination?.address?.name}}
                                                    <!-- <input type="text" id="dropoffAddress" class=""
                                                        placeholder="Enter the address" name="pickupAddress" googlePlace
                                                        formControlName="name"
                                                        (onSelect)="setDestinationAddress($event)" /> -->
                                                </div>

                                                <!-- <div
                                                    *ngIf="(dropOffForm.get('address.name')?.errors || dropOffForm.get('address.coords')?.value.length === 0) && submitted">
                                                    <div *ngIf="(dropOffForm.get('address.name')?.errors?.required || dropOffForm.get('address.coords')?.value.length === 0)"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Address is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                <div *ngIf="
                            isAddressInvalid(
                              dropOffForm.get('address.name'),
                              dropOffForm.get('address.coords')
                            ) && submitted
                          ">
                                                    <div class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Address is required
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <details class="col-span-full group">
                                            <summary class="flex items-center justify-between cursor-pointer">
                                                <div class="text-xs font-bold underline flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="size-4">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
                                                    </svg>
                                                    Additional Information
                                                </div>
                                                <svg class="h-5 w-5 transition-transform duration-300 ease-in-out group-open:rotate-180"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                                </svg>
                                            </summary>
                                            <div
                                                class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-6 items-end border p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 border-zinc-950/10 dark:border-white/10">
                                                <ng-container formGroupName="address">
                                                    <!-- Floor -->
                                                    <div class="sm:col-span-2">
                                                        <label for="floordest"
                                                            class="block text-sm font-medium text-main-secondary">Floor
                                                        </label>
                                                        <div class="mt-1 input-display">
                                                            {{tripData?.pickup?.address.floor}}
                                                            <!-- <input formControlName="floor" type="text" name="floordest"
                                                                id="floordest" /> -->
                                                        </div>
                                                        <!-- <div *ngIf="originAddressAdditionalForm.get('floor')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('floor')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Floor is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>

                                                    <!-- APT/SUITE -->

                                                    <div class="sm:col-span-2">
                                                        <label for="aptOrSuitedest"
                                                            class="block text-sm font-medium text-main-secondary">APT/SUITE
                                                        </label>
                                                        <div class="mt-1 input-display">
                                                            {{tripData?.pickup?.address.aptSuiteRoom}}

                                                            <!-- <input formControlName="aptSuiteRoom" type="text"
                                                                name="aptOrSuitedest" id="aptOrSuitedest" /> -->
                                                        </div>
                                                        <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            APT/SUITE is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                    </div>
                                                </ng-container>

                                                <!-- Place Type -->
                                                <div class="sm:col-span-2">
                                                    <label for="placeNamedest"
                                                        class="block text-sm font-medium text-main-secondary">Place Type
                                                    </label>
                                                    <div class="mt-1 input-display">
                                                        {{tripData?.pickup?.placeName}}
                                                        <!-- <select name="placeNameDest" id="placeNameDest"
                                                            formControlName="placeName">
                                                            <option value="">Select Place Name</option>
                                                            <option *ngFor="let placetype of placetypes"
                                                                value="{{ placetype.title }}">
                                                                {{ placetype.title }}
                                                            </option>
                                                        </select> -->
                                                    </div>
                                                    <!-- <div
                                                    *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors && submitted">
                                                    <div *ngIf="originAddressAdditionalForm.get('aptOrSuite')?.errors?.required"
                                                        class="error">
                                                        <p class="mt-2 text-red-600 text-xs">
                                                            Home/Facility Name is required
                                                        </p>
                                                    </div>
                                                </div> -->
                                                </div>

                                                <!-- Contact Number -->
                                                <div class="sm:col-span-2">
                                                    <label for="phoneNumberdest"
                                                        class="block text-sm font-medium text-main-secondary">Contact
                                                        Number
                                                    </label>
                                                    <div class="mt-1 input-display" phoneNumberFormat [phoneNumber]="tripData?.destination?.phoneNumber">
                                                        {{tripData?.destination?.phoneNumber}}

                                                        <!-- <input formControlName="phoneNumber" type="text"
                                                            name="phoneNumberdest" id="phoneNumberdest"
                                                            maxlength="11" /> -->
                                                    </div>
                                                    <!-- <div *ngIf="submitted && dropOffForm.get('phoneNumber')?.errors">
                                                        <p *ngIf="submitted && (dropOffForm.get('phoneNumber')?.errors?.minlength || dropOffForm.get('phoneNumber')?.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                                                            Minimum 10 digits are required and maximum 11
                                                            digits are allowed
                                                        </p>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </details>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">

                        <div class="sm:col-span-2">
                            <label for="appointmentType" class="block text-sm font-medium text-main-secondary">
                                Appointment Type
                            </label>

                            <div class="mt-1 input-display">
                                {{
                                preAppointmentTypes?.[newTripForm.get('appointmentType')?.value]
                                ? (preAppointmentTypes[newTripForm.get('appointmentType')?.value]?.title | titlecase)
                                : ''
                                }}
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <label for="miles" class="block text-sm font-medium text-main-secondary">Miles</label>
                            <div class="mt-1 input-display">
                                {{tripData?.miles}}
                                <!-- <input type="text" formControlName="miles" id="miles" /> -->
                            </div>
                            <!-- <div *ngIf="form.miles.errors && submitted">
                                <div *ngIf="form.miles.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        Miles is required
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="sm:col-span-2">
                            <label for="additionalPassenger"
                                class="block text-sm font-medium text-main-secondary">Escorts</label>
                            <div class="mt-1 input-display">
                                {{tripData?.additionalPassenger}}
                                <!-- <select id="additionalPassenger" formControlName="additionalPassenger">
                                    <option value="">Select Additional Passengers</option>
                                    <option *ngFor="let noOfEscort of [1, 2, 3, 4, 5]" value="{{ noOfEscort }}">
                                        {{ noOfEscort }}
                                    </option>
                                </select> -->
                            </div>
                            <!-- <div *ngIf="form.additionalPassenger.errors && submitted">
                                <div *ngIf="form.additionalPassenger.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        No. Of Escorts is required
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="sm:col-span-2">
                            <label for="additionalPassenger"
                                class="block text-sm font-medium text-main-secondary">Requester Name</label>
                            <div class="mt-1 input-display">
                                {{(tripData?.requesterName) | titlecase}}
                                <!-- <input type="text" formControlName="requesterName" id="requesterName" /> -->
                            </div>
                            <!-- <div *ngIf="form.additionalPassenger.errors && submitted">
                                <div *ngIf="form.additionalPassenger.errors.required" class="error">
                                    <p class="mt-2 text-red-600 text-xs">
                                        No. Of Escorts is required
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <!-- <div class="sm:col-span-2">
                            <label for="additionalPassenger" class="block text-sm font-medium text-main-secondary">Distance</label>
                            <div class="mt-1">
                                <input type="text" formControlName="distance" id="distance" />
                            </div>
                        </div> -->
                        <!-- <div class="sm:col-span-2">
                            <label for="additionalPassenger" class="block text-sm font-medium text-main-secondary">Duration</label>
                            <div class="mt-1">
                                <input type="text" formControlName="duration" id="duration" />
                            </div>
                        </div> -->

                    </div>
                    <div class="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-6">
                        <div class="sm:col-span-3">
                            <label class="block text-sm font-medium text-main-secondary">Billing Notes</label>
                    
                            <div class="mt-1 border rounded-md p-2 min-h-[80px] text-main-secondary focus:outline-none focus:ring focus:ring-main-secondary/40 input-display"
                                contenteditable="false">
                                {{ tripData?.billingNotes }}
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 space-y-2">
                        <!-- Attachments Header -->
                        <div *ngIf="form.attachments.value.length" class="flex items-center justify-between">
                            <div class="flex items-center gap-1 text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                                </svg>
                                <h2 class="subheading text-primary">Attachments</h2>
                            </div>
                        </div>

                        <!-- Upload Section -->
                        <div *ngIf="form.attachments.value.length" class="border-2 border-dashed border-zinc-950/10 dark:border-white/10 rounded-lg flex items-center p-2">
                            <!-- Uploaded Files List -->
                            <ul class="relative max-w-full flex w-auto snap-x snap-mandatory gap-4 overflow-x-auto p-4"
                                >
                                <li *ngFor="let file of attachmentForm.controls; let i = index"
                                    class="relative flex w-56 shrink-0 snap-center items-center gap-2 rounded-lg border border-zinc-950/10 dark:border-white/10 p-2 shadow">
                                    <div class="grid h-12 w-10 place-content-center flex-shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="size-full text-primary"
                                            viewBox="0 0 16 16">
                                            <g fill="currentColor">
                                                <path
                                                    d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
                                                <path
                                                    d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102c.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645a20 20 0 0 0 1.062-2.227a7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136c.075-.354.274-.672.65-.823c.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538c.007.187-.012.395-.047.614c-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686a5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465c.12.144.193.32.2.518c.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416a.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95a11.6 11.6 0 0 0-1.997.406a11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="flex flex-col truncate">
                                        <div class="text-sm-dark truncate flex-1">
                                            {{ file.value.filename }}
                                        </div>
                                        <div class="text-sm-light flex gap-1">
                                            <span>&#x2022;</span>
                                            <a href="{{ file.value.url }}" target="_blank"
                                                class="cursor-pointer hover:text-primary hover:underline">Download</a>
                                        </div>
                                    </div>
                                    <button type="button"
                                        class="absolute -top-2.5 -right-2.5 btn btn-danger rounded-full size-6 grid place-content-center"
                                        (click)="removeAttachment(i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="size-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                            <!-- <div>
                                <input type="file" accept="application/pdf" #fileInput class="hidden"
                                    (change)="uploadAttachment($event)" />
                                <div class="cursor-pointer flex shrink-0 snap-center items-center gap-2 rounded-lg border border-zinc-950/10 dark:border-white/10 p-2 shadow h-full"
                                    (click)="fileInput.click()">
                                    <div class="grid h-12 w-10 place-content-center flex-shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="size-5">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M12 4.5v15m7.5-7.5h-15" />
                                        </svg>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!-- Addons -->
                    <div name="addons" *ngIf="addonsFormGroups && addonsFormGroups.length">
                        <div class="mt-4">
                            <h3 class="text-lg font-medium leading-6 text-main-dark">
                                Addon Services
                            </h3>
                        </div>
                        <div class="space-y-2">
                            <div class="mt-4 bg-main-base-100 border-2 border-dashed border-main-base dark:border-white/10 p-2 rounded-lg"
                                *ngFor="let addonItem of addonsFormGroups; index as addonIndex" [formGroup]="addonItem">
                                <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                                    <div class="sm:col-span-2">
                                        <label class="block text-sm font-medium text-main-secondary">
                                            Item {{ addonIndex + 1 }}
                                        </label>
                                        <div class="mt-1 input-display">
                                            {{ getAddonDisplay(addonItem?.get('addon')?.value) }}
                                        </div>
                                    </div>

                                    <div class="sm:col-span-2">
                                        <label class="block text-sm font-medium text-main-secondary">Quantity</label>
                                        <div class="mt-1 input-display">
                                            {{ addonItem?.get('quantity')?.value || '—' }}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- <div class="grid grid-cols-1 gap-2 sm:grid-cols-6 items-end">
                                                        <div class="mt-4">
                                                            <button type="button" class="btn btn-secondary" (click)="addAddonsItem()">
                                                                + Addon
                                                            </button>
                                                        </div>
                                                    </div> -->
                        </div>
                    </div>
                </div>

            </form>
            <div name="Events">
                <div class="mt-4 flex justify-between items-center">
                    <h3 class="text-lg font-medium leading-6 text-main-dark">
                        Events
                    </h3>
                    <button class="btn btn-secondary" (click)="openMapModal(true)" >Add Event</button>
                </div>
                <form [formGroup]="eventForm">
                    <div formArrayName="events" class="space-y-4">

                        <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-6">
                            <div *ngFor="let event of eventsArray.controls; let i = index" [formGroupName]="i"
                                class="sm:col-span-2">
                                <div class="flex justify-between items-center">
                                    <label for="" class="block text-sm font-medium text-main-secondary">{{
                                        event.get('status')?.value | titlecase }} <button class="cursor-pointer"><span class="text-main-secondary">(<span class="text-blue-400 text-sm"  (click)="openMapModal(event.value)">Edit</span> / <span class="text-red-500 text-sm"  (click)="onDeleteEvent(event.value, i)">Delete</span>)</span></button></label>
                                    <div class="flex justify-between items-center gap-1">
                                        <span class="text-blue-400 text-xs">({{ event.get('latitude')?.value |
                                            number:'1.6-6' }}, {{ event.get('longitude')?.value |
                                            number:'1.6-6'}})</span>
                                        <button  type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                                <div class="mt-1">
                                    <!-- Time selector -->
                                    <input type="text" formControlName="time" [owlDateTime]="dtPicker"
                                        [owlDateTimeTrigger]="dtPicker" class="border p-1 w-full" />
                                    <owl-date-time #dtPicker></owl-date-time>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            </div>


            <div class="pt-4">
                <div class="flex justify-end gap-2">
                    <button type="submit" (click)="onAdjustTrip()" class="ml-3 btn btn-secondary">
                        Save
                    </button>
                    <!-- <button type="button" (click)="dummyData()" class="ml-3 btn btn-primary">Dummy Data</button> -->
                </div>
            </div>
        </div>
        <!-- Member Modal -->
        <div *ngIf="selectedMember" class="flex-shrink-0 lg:w-96">
            <div
                class="rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg p-4">
                <div class="flex justify-between items-start">
                    <div class="flex-1 flex items-center gap-2">
                        <div
                            class="inline-grid size-10 shrink-0 rounded-[--avatar-radius] align-middle outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] [--avatar-radius:20%] [--ring-opacity:20%] *:rounded-[--avatar-radius] dark:outline-white/[--ring-opacity] overflow-hidden">
                            <img alt="Profile Image" class="relative size-full text-gray-400 ng-star-inserted" [src]="
                  selectedMember?.profileImageURL
                    ? selectedMember.profileImageURL
                    : 'assets/images/profileImagePlaceholder.png'
                " />
                        </div>
                        <div class="flex flex-col">
                            <div class="text-primary text-sm-dark font-bold leading-tight">
                                {{ ((selectedMember?.displayName) | titlecase)  || "N/A" }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <span class="badge-success">{{
                            selectedMember.gender | titlecase
                            }}</span>
                    </div>
                </div>
                <div class="space-y-8">
                    <!-- Trip Information -->
                    <div>
                        <dl
                            class="mt-2 divide-y divide-zinc-950/10 dark:divide-white/10 border-t border-b border-zinc-950/10 dark:border-white/10">
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">
                                    Weight <span class="text-xs-light">(lbs)</span>
                                </dt>
                                <dd class="text-xs-dark">
                                    {{ selectedMember.weight ? selectedMember.weight : "N/A" }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Contact Number</dt>
                                <dd class="text-xs-dark">
                                    <div class="leading-tight" phoneNumberFormat [phoneNumber]="selectedMember?.contactNumber">
                                        {{ selectedMember?.contactNumber }}
                                    </div>
                                    <!-- <div class="leading-tight" class="text-xs-light">
                                        {{selectedMember.phoneNumber}}
                                    </div> -->
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Email</dt>
                                <dd class="text-xs-dark">
                                    {{ selectedMember.email }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Spoken Languages</dt>
                                <dd class="text-xs-dark flex gap-1">
                                    <span class="">
                                        {{(selectedMember?.languageSpoken ? (selectedMember?.languageSpoken | titlecase) : "N/A") }}
                                    </span>
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Address</dt>
                                <dd class="text-xs-dark">{{ selectedMember.address?.name }}</dd>
                            </div>
                            <!-- <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Member Type</dt>
                                <dd class="text-xs-dark">
                                    <div class="badge-primary">
                                        {{ selectedMember.memberType | titlecase }}
                                    </div>
                                </dd>
                            </div> -->
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Level of Service</dt>
                                <dd class="text-xs-dark">
                                    <span
                                        *ngIf="selectedMember?.levelOfService && preLevelOfServiceList?.[selectedMember.levelOfService]; else losNotFound">
                                        {{(preLevelOfServiceList[selectedMember.levelOfService]?.title | uppercase)}}
                                    </span>
                                    <ng-template #losNotFound>N/A</ng-template>

                                    <span class="text-xs-light" *ngIf="preSpaceTypeList && preSpaceTypeList[selectedMember.spaceType]">
                                        ({{preSpaceTypeList[selectedMember.spaceType].title | uppercase}})
                                    </span>
                                </dd>
                            </div>
                            <!-- <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Funding Source</dt>
                                <dd class="text-xs-dark">
                                    <span
                                        *ngIf="selectedMember?.fundingsource && preFundingSource?.[selectedMember.fundingsource]; else typeNotFound">
                                        {{ preFundingSource[selectedMember.fundingsource]?.title }}
                                    </span>
                                    <ng-template #typeNotFound>N/A</ng-template>
                                </dd>
                            </div> -->
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Responsible Party Name</dt>
                                <dd class="text-xs-dark">
                                    {{ (selectedMember.responsibleParty?.name | titlecase) || "N/A" }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Responsible Party Phone Number</dt>
                                <dd class="text-xs-dark" phoneNumberFormat [phoneNumber]="selectedMember.responsibleParty?.phoneNumber">
                                    {{ selectedMember.responsibleParty?.phoneNumber || "N/A" }}
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Appointment Type</dt>
                                <dd class="text-xs-dark">
                                    <span
                                        *ngIf="selectedMember?.appointmentType && preAppointmentTypes?.[selectedMember.appointmentType]; else typeNotFound">
                                        {{preAppointmentTypes[selectedMember.appointmentType]?.title | titlecase }}
                                    </span>
                                    <ng-template #typeNotFound>N/A</ng-template>
                                </dd>
                            </div>
                            <div class="flex justify-between py-3 text-xs font-medium items-center">
                                <dt class="text-xs-light">Status</dt>
                                <dd class="text-xs-dark">
                                    <span [ngClass]="{'badge-success': selectedMember?.isActive,'badge-danger': !selectedMember?.isActive}">
                                        {{ selectedMember?.isActive ? "Active" : "Inactive" }}
                                    </span>
                                </dd>
                            </div>
                            <div class="flex flex-col justify-between text-xs font-medium items-start">
                                <dt class="text-xs-light">General Notes</dt>
                                <div class="w-72 line-clamp-2">
                                    <dd class="text-xs-dark">
                                        {{selectedMember.generalNotes ? (selectedMember.generalNotes) : "N/A"}}
                                    </dd>
                                </div>
                            </div>
                            <div class="flex flex-col justify-between py-3 text-xs font-medium items-start">
                                <dt class="text-xs-light">Private Notes</dt>
                                <div class="w-72 line-clamp-2">
                                    <dd class="text-xs-dark">
                                        {{selectedMember.privateNotes ? (selectedMember.privateNotes) : "N/A" }}
                                    </dd>
                                </div>
                            </div>
                            <div class="flex flex-col justify-between py-3 text-xs font-medium items-start">
                                <dt class="text-xs-light">Billing Notes</dt>
                                <div class="w-72 line-clamp-2">
                                    <dd class="text-xs-dark">
                                        {{selectedMember.billingNotes ? (selectedMember.billingNotes) : "N/A" }}
                                    </dd>
                                </div>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>

        <!-- Calculate Fare Modal -->
    </div>
</section>

<app-member-wrapper *ngIf="addMember" [memberId]="form.member.value" (onSave)="onSaveMember($event)"
    (onCloseModal)="addMember = false"></app-member-wrapper>
<app-trip-detail-modal *ngIf="isDetailModal" [tripId]="tripId" [source]="isFromBilling ? 'billing':'trips'"
    (closeModal)="isDetailModal = false"></app-trip-detail-modal>
<app-address-picker-modal *ngIf="mapObj" [event]="mapObj" [existingEvents]="eventsArray.value" (locationChanged)="onLocationChanged($event)"
    (closeModal)="mapObj = null"></app-address-picker-modal>